module.exports = __webpack_public_path__ + "974b95b7f51c1f91fb0d7cbb9e830b97.svg";